import '../../../styles/forms.css.js';
import '../../../styles/fonts.css.js';
import classNames from 'classnames';
import React__default from 'react';
import Tooltip from '../../Layout/Tooltip/Tooltip.js';
import styles from './Button.module.scss.js';

/**
 * Button component
 */
const Button = ({ type = 'primary', buttonType = 'button', allCaps = true, textColor, icon, width, disabled = false, size = 'medium', onClick, tooltipMessage = '', stopPropagation = true, children, }) => {
    const combinedStyles = {
        ...(textColor ? { color: textColor } : {}),
        ...(width ? { width: width } : {}),
        ...(disabled ? { opacity: 0.2, cursor: 'not-allowed' } : {}),
        ...(allCaps ? { textTransform: 'uppercase' } : {}),
    };
    /* if (!label) return <></>; */
    const handleClick = (event) => {
        if (stopPropagation)
            event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    const ButtonContent = () => {
        return (React__default.createElement("div", null, type === 'link' ? (React__default.createElement("span", { className: classNames(styles.SE__Button, styles[`SE__Button__${type}`], styles[`SE__Button__${type}__${size}`]), style: combinedStyles, onClick: event => handleClick(event) }, icon ? (React__default.createElement("div", { style: { display: 'table' } },
            React__default.createElement("div", { style: { display: 'table-row' } },
                React__default.createElement("div", { style: {
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        paddingRight: children ? 5 : 0,
                    } }, icon),
                React__default.createElement("div", { style: { display: 'table-cell', verticalAlign: 'middle' } }, children)))) : (children))) : (React__default.createElement("button", { type: buttonType, disabled: disabled, className: classNames(styles.SE__Button, styles[`SE__Button__${type}`], styles[`SE__Button__${type}__${size}`]), style: combinedStyles, onClick: event => handleClick(event) }, icon ? (React__default.createElement("div", { style: { display: 'table' } },
            React__default.createElement("div", { style: { display: 'table-row' } },
                React__default.createElement("div", { style: {
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        paddingRight: children ? 5 : 0,
                    } }, icon),
                React__default.createElement("div", { style: { display: 'table-cell', verticalAlign: 'middle' } }, children)))) : (children)))));
    };
    return (React__default.createElement(React__default.Fragment, null, tooltipMessage.length > 2 ? (React__default.createElement(Tooltip, { title: tooltipMessage },
        React__default.createElement("div", { style: { display: 'inline-block' } },
            React__default.createElement(ButtonContent, null)))) : (React__default.createElement(ButtonContent, null))));
};

export { Button as default };
//# sourceMappingURL=Button.js.map
